// import service from '@/services/types/clasificacion'

export const namespaced = true;

export const state = () => ({
  list: [
    "producto",
    "servicio",
    // {
    //   // id: 1,
    //   // value: '01',
    //   annotation: 'producto'
    // },
    // {
    //   // id: 2,
    //   // value: '02',
    //   annotation: 'servicio'
    // }
  ],
});

export const mutations = {
  LIST: (state, objs) => (state.list = objs),
};

export const actions = {
  list: ({ commit, state }) =>
    // if (state.list.length > 0) return state.list

    // return service.list().then(result => {
    //   commit('LIST', result)
    //   return result
    // })

    state.list,
};
